/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';

/**
 * Lazy per-tab data hook. Runs `fetcher` when the tab first mounts (i.e. is first
 * activated) and whenever `deps` change (e.g. the shared date range). Because the
 * container keeps an activated tab mounted, re-selecting it does NOT refetch — that
 * satisfies the "no redundant refetch" requirement.
 *
 * Returns { status: 'loading' | 'ok' | 'error', data, reload }.
 * Emptiness is decided by each tab from `data` (shapes differ per endpoint).
 */
export default function useTabData(fetcher, deps = []) {
  const [status, setStatus] = useState('loading');
  const [data, setData] = useState(null);
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    let alive = true;
    setStatus('loading');
    Promise.resolve()
      .then(fetcher)
      .then((d) => { if (alive) { setData(d); setStatus('ok'); } })
      .catch(() => { if (alive) { setData(null); setStatus('error'); } });
    return () => { alive = false; };
  }, [...deps, nonce]);

  return { status, data, reload: () => setNonce((n) => n + 1) };
}
